export class SupplierDashboardBiddingSessionsStats {
	public numAllSessions: number;
	public numPinnedSessions: number;
	public numClosingSoonSessions: number;
	public numOpenToBidSessions: number;
	public numParticipatingSessions: number;
	public numNotParticipatedStartedTodaySessions: number;
	public numNotParticipatedStartedEarlierSessions: number;
	public numClosedSessions: number;
	public numWonSessions: number;
	public numLostSessions: number;
	public numEndedSessions: number;

	constructor(supplierDashboardBiddingSessionsStats: SupplierDashboardBiddingSessionsStats) {
		Object.assign(this, supplierDashboardBiddingSessionsStats);
	}
}
